import { AccountsResponseDto } from '~/models/accounts/accounts';
import { myQredApi } from '../../_baseApi/myQredApi.base.api';

export const accountsApi = myQredApi.injectEndpoints({
  endpoints: (build) => ({
    getAccounts: build.query<AccountsResponseDto, void>({
      query: () => `/account/v1/accounts/me`,
      providesTags: ['Accounts'],
    }),
  }),
});
export const { useLazyGetAccountsQuery, useGetAccountsQuery } = accountsApi;
